import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGiftCardDetail } from "src/models/Prices/GiftCard.models";

interface GiftCardDetailState {
  giftCardDetails: IGiftCardDetail[];
  giftCardDetailToEdit: IGiftCardDetail | null;
}

const initialState: GiftCardDetailState = {
  giftCardDetails: [],
  giftCardDetailToEdit: null,
};

const GiftCardDetailSlice = createSlice({
  name: "GiftCardDetail",
  initialState,
  reducers: {
    setGiftCardDetailList: (
      state,
      action: PayloadAction<IGiftCardDetail[]>
    ) => {
      state.giftCardDetails = action.payload;
    },
    setGiftCardDetailToEdit: (
      state,
      action: PayloadAction<IGiftCardDetail | null>
    ) => {
      state.giftCardDetailToEdit = action.payload;
    },
    concatListGiftCardDetail: (
      state: GiftCardDetailState,
      action: PayloadAction<IGiftCardDetail[]>
    ) => {
      state.giftCardDetails = [...state.giftCardDetails.concat(action.payload)];
    },
    addGiftCardDetail: (state, action: PayloadAction<IGiftCardDetail>) => {
      state.giftCardDetails.push(action.payload);
    },
    updateGiftCardDetail: (state, action: PayloadAction<IGiftCardDetail>) => {
      let itemIndex = state.giftCardDetails.findIndex(
        item => item.giftCardDetailId === action.payload.giftCardDetailId
      );
      if (itemIndex !== -1) state.giftCardDetails[itemIndex] = action.payload;
    },
    deleteGiftCardDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.giftCardDetails.filter(
        item => item.giftCardDetailId !== action.payload
      );
      state.giftCardDetails = newArray;
    },
  },
});

export const {
  setGiftCardDetailList,
  concatListGiftCardDetail,
  setGiftCardDetailToEdit,
  addGiftCardDetail,
  updateGiftCardDetail,
  deleteGiftCardDetail,
} = GiftCardDetailSlice.actions;

export default GiftCardDetailSlice.reducer;
